/* eslint-disable */
import React from 'react';
import Highcharts from 'highcharts/highcharts.js';
import HighchartsReact from 'highcharts-react-official';
import CELogo from '../../../assets/images/CElogo.jpg';
import CEsignature from '../../../assets/images/CEsignature.png';
import CEHorizontalLogo from '../../../assets/images/CEHorizontalLogo.png';
import celeaf from '../../../assets/images/celeaf.png';
import CELogoCircle from '../../../assets/images/CELogoCircle.png';
import { formatAccountingNumber, parseMoney, percentRounded } from '../utils/index';
import { premiumChart, netPremiumWrittenToSurplus, reinsuranceToGPW, liquidityRatio, combinedRatio, opexRatio, breakEvenRatio, surplusToGRIF000s } from './CeChartHelper';

const IowaReport = (props) => {
    const abbreviation = props.abbreviation;
    const fye = props.filters.year;
    const nextYear = fye + 1
    const selectedYear = props.filters.year;
    const calcs = props.calcs.you;
    const peerCalcs = props.calcs.avg;
    const calcsYOY = calcs?.[selectedYear]?.['change_over_year'];
    const formattedDate = props.dateIssued;
    const years = props?.filters?.year ? [props?.filters?.year - 4, props?.filters?.year - 3, props?.filters?.year - 2, props?.filters?.year - 1, props?.filters?.year] : [];
    const getSummaryTable = (calcs) => {
        let tableRows = []
        const rows = [
            {
                key: 'empty_row'
            },
            {
                key: "investments",
                metric: "Investments",
                dollarSign: true
            },
            {
                key: "admitted_assets",
                metric: "Admitted Assets",
            },
            {
                key: "surplus",
                metric: "Surplus",
            },
            {
                key: 'empty_row'
            },
            {
                key: "gross_premium_written",
                metric: "Premium Written",
            },
            {
                key: "net_premium_written",
                metric: "Net Premium Written",
            },
            {
                key: "premium_earned",
                metric: "Premium Earned",
            },
            {
                key: "underwriting_gain_loss",
                metric: "Underwriting Gain (Loss)",
            },
            {
                key: "net_income_before_income_taxes",
                metric: "Net Profit Before Taxes",
            },
        ]

        tableRows = rows.map(r => {
            if (r.key == 'empty_row') {
                return (
                    <tr style={{ 'height': '13.3px' }}>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                )
            } else {
                let yearVals = years.map(y => {
                    return formatAccountingNumber(calcs.you?.[y]?.[r.key], { showDollarSign: r.dollarSign, parenthesesForNegatives: true, round: true, decimalPlaces: 0 })
                })
                return (
                    <tr>
                        <td>{r.metric}</td>
                        <td className='ce-financial-sum-table-cell'>{yearVals[0]}</td>
                        <td className='ce-financial-sum-table-cell'>{yearVals[1]}</td>
                        <td className='ce-financial-sum-table-cell'>{yearVals[2]}</td>
                        <td className='ce-financial-sum-table-cell'>{yearVals[3]}</td>
                        <td className='ce-financial-sum-table-cell'>{yearVals[4]}</td>
                    </tr>
                )
            }
        })

        return (
            <table className='ce-financial-sum-table'>
                <thead>
                    <tr>
                        <td></td>
                        {years.map(y => <td style={{ 'textDecoration': 'underline', 'textAlign': 'center', 'fontWeight': 'bold' }}>{y}</td>)}
                    </tr>
                </thead>
                <tbody>
                    {tableRows}
                </tbody>
            </table>
        )
    }

    const premiumWritten = percentRounded(calcs?.[selectedYear]?.premium_written_five_yr_gr, 1, true)
    const netPremiumWritten = percentRounded(calcs?.[selectedYear]?.net_premium_written_five_yr_gr, 1, true)
    const premiumEarned = percentRounded(calcs?.[selectedYear]?.premium_earned_five_yr_gr, 1, true)
    const comparePremium = calcs?.[selectedYear]?.premium_written_five_yr_gr > 0 && calcs?.[selectedYear]?.net_premium_written_five_yr_gr > 0 && calcs?.[selectedYear]?.premium_earned_five_yr_gr > 0 ? 'grew' : 'changed';

    const net_premium_to_surplus_ratio = percentRounded(calcs?.[selectedYear]?.net_premium_to_surplus_ratio, 100, true)
    const peers_net_premium_to_surplus_ratio = percentRounded(peerCalcs?.[selectedYear]?.net_premium_to_surplus_ratio, 100, true)
    const min_peers_net_premium_to_surplus_ratio = percentRounded(props.calcs?.min?.net_premium_to_surplus_ratio, 100, true)
    const max_peers_net_premium_to_surplus_ratio = percentRounded(props.calcs?.max?.net_premium_to_surplus_ratio, 100, true)
    const compare_net_premium_to_surplus_ratio = calcs?.[selectedYear]?.net_premium_to_surplus_ratio > peerCalcs?.[selectedYear]?.net_premium_to_surplus_ratio ? 'higher' : 'lower';
    const compare_capacity = compare_net_premium_to_surplus_ratio == 'higher' ? 'lower' : 'greater';

    const reinsurance_to_gpw_ratio = percentRounded(calcs?.[selectedYear]?.reinsurance_to_gpw_ratio, 100, true)
    const peers_reinsurance_to_gpw_ratio = percentRounded(peerCalcs?.[selectedYear]?.reinsurance_to_gpw_ratio, 100, true)
    const min_peers_reinsurance_to_gpw_ratio = percentRounded(props.calcs?.min?.reinsurance_to_gpw_ratio, 100, true)
    const max_peers_reinsurance_to_gpw_ratio = percentRounded(props.calcs?.max?.reinsurance_to_gpw_ratio, 100, true)

    const liquidity_ratio = percentRounded(calcs?.[selectedYear]?.liquidity_ratio, 100, true);
    const peers_liquidity_ratio = percentRounded(peerCalcs?.[selectedYear]?.liquidity_ratio, 100, true)
    const min_peers_liquidity_ratio = percentRounded(props.calcs?.min?.liquidity_ratio, 100, true)
    const max_peers_liquidity_ratio = percentRounded(props.calcs?.max?.liquidity_ratio, 100, true)

    const compareUnderwritingGainLoss = calcs?.[selectedYear]?.underwriting_gain_loss > 0 ? 'gain' : 'loss';
    const underwriting_gain_loss = formatAccountingNumber(calcs?.[selectedYear]?.underwriting_gain_loss, { showDollarSign: true, parenthesesForNegatives: false, round: true, decimalPlaces: 0 });

    const compareNetLossAndOpex = (calcsYOY?.net_losses_incurred > 0 && calcsYOY?.operating_expenses > 0) ? 'increased' : (calcsYOY?.net_losses_incurred < 0 && calcsYOY?.operating_expenses < 0) ? 'decreased' : 'changed';
    const net_losses_incurredYOY = percentRounded(calcsYOY?.net_losses_incurred, 1, compareNetLossAndOpex == 'changed');
    const operating_expensesYOY = percentRounded(calcsYOY?.operating_expenses, 1, compareNetLossAndOpex == 'changed');

    const combined_ratio_no_one_year = percentRounded(calcs?.[selectedYear]?.combined_ratio_no_one_year, 100, true)
    const peers_combined_ratio_no_one_year = percentRounded(peerCalcs?.[selectedYear]?.combined_ratio_no_one_year, 100, true)
    const combined_ratio_no_five_year_avg = percentRounded(calcs?.[selectedYear]?.combined_ratio_no_five_year_avg, 100, true)
    const peers_combined_ratio_no_five_year_avg = percentRounded(peerCalcs?.[selectedYear]?.combined_ratio_no_five_year_avg, 100, true)

    const operating_expense_ratio = percentRounded(calcs?.[selectedYear]?.operating_expense_ratio, 100, true)
    const peers_operating_expense_ratio = percentRounded(peerCalcs?.[selectedYear]?.operating_expense_ratio, 100, true)
    const min_peers_operating_expense_ratio = percentRounded(props.calcs?.min?.operating_expense_ratio, 100, true)
    const max_peers_operating_expense_ratio = percentRounded(props.calcs?.max?.operating_expense_ratio, 100, true)

    const break_even_ratio = percentRounded(calcs?.[selectedYear]?.break_even_ratio_no, 100, true)
    const peers_break_even_ratio = percentRounded(peerCalcs?.[selectedYear]?.break_even_ratio_no, 100, true)
    const min_peers_break_even_ratio = percentRounded(props.calcs?.min?.break_even_ratio_no, 100, true)
    const max_peers_break_even_ratio = percentRounded(props.calcs?.max?.break_even_ratio_no, 100, true)


    const investments = formatAccountingNumber(calcs?.[selectedYear]?.investments, { showDollarSign: true, parenthesesForNegatives: true, round: true, decimalPlaces: 0 })
    const investmentsYOY = percentRounded(calcsYOY?.investments)
    const compare_investments = calcs?.[selectedYear]?.investments > calcs?.[selectedYear - 1]?.investments ? 'increased' : 'decreased';

    const surplus = calcs?.[selectedYear]?.surplus ? formatAccountingNumber(calcs?.[selectedYear]?.surplus, { showDollarSign: true, parenthesesForNegatives: true, round: true, decimalPlaces: 0 }) : '$0';
    const difSurplus = Math.abs(calcs?.[selectedYear]?.surplus - calcs?.[selectedYear - 1]?.surplus);
    const finalDifSurplus = formatAccountingNumber(difSurplus, { showDollarSign: true, parenthesesForNegatives: true, round: true, decimalPlaces: 0 });
    const compare_surplus =  calcs?.[selectedYear]?.surplus > calcs?.[selectedYear - 1]?.surplus ? 'increased' : 'decreased';
    const surplusYOY = percentRounded(calcsYOY?.surplus)
    const surplus50 = calcs?.[selectedYear]?.surplus ? formatAccountingNumber(calcs?.[selectedYear]?.surplus * .5, { showDollarSign: true, parenthesesForNegatives: true, round: true, decimalPlaces: 0 }) : '$0';
    const surplus10 = calcs?.[selectedYear]?.surplus ? formatAccountingNumber(calcs?.[selectedYear]?.surplus * .1, { showDollarSign: true, parenthesesForNegatives: true, round: true, decimalPlaces: 0 }) : '$0';
    const surplus5 = calcs?.[selectedYear]?.surplus ? formatAccountingNumber(calcs?.[selectedYear]?.surplus * .05, { showDollarSign: true, parenthesesForNegatives: true, round: true, decimalPlaces: 0 }) : '$0';
    const admitted_assets5 = calcs?.[selectedYear]?.admitted_assets ? formatAccountingNumber(calcs?.[selectedYear]?.admitted_assets * .05, { showDollarSign: true, parenthesesForNegatives: true, round: true, decimalPlaces: 0 }) : '$0';
        
    return (
        <div className='ce-report-container'>
            <div className='ce-cover-page'>
                <div className='ce-cover-page-info'>
                    <div>{props.real_name?.toUpperCase()}</div>
                    <div>MANAGEMENT & DIRECTORS LETTER</div>
                    <div>{`DECEMBER 31, ${props?.filters?.year}`}</div>
                </div>
                <div className='ce-cover-page-footer'>
                    <img className='ce-logo-jpg' src={CELogo} alt="CE Logo" />
                </div>
            </div>
            <div className='ce-portrait-view-w-letterhead'>
                {props.letterHead
                    ? (<div className='ce-letterhead-intro-top-container'>
                            <div className='ce-letterhead-intro-top'>
                                <div className='ce-web-address'>cainellsworth.com</div>
                            </div>
                            <div className='ce-white-circle-logo'></div>
                            <img className='ce-horizontal-logo' src={CEHorizontalLogo} alt="CE Logo Horizontal" />
                        </div>)
                    : <div className='ce-letterhead-intro-top-container' />
                }
                <div className='ce-page-container'> 
                    <div className='ce-intro-letter'>
                        <div className='ce-intro-company-header'>
                            <div>{props.real_name}</div>
                            <div>{props.location}</div>
                        </div>
                        <div className='ce-intro-dear'>To the Management and Directors:</div>
                        <div className='ce-paragraph'>
                            As the result of our engagement to compile the financial statements of {props.real_name} (hereinafter referred to as {abbreviation}) as of and for the period
                            ending December 31, {props?.filters?.year}, we make the following comments to assist you with interpreting
                            your company’s financial statements and assessing statutory compliance.<span className='sentence-end'></span>The information and
                            comments contained herein are presented for supplementary analysis purposes only, and we have
                            not audited or reviewed the financial statements from which our comments are
                            derived.<span className='sentence-end'></span>Furthermore, our report on the financial statements, dated {formattedDate}, 
                            should be read in conjunction with this letter.
                        </div>
                    </div>
                    <div className='ce-financial-summary'>
                        <div className='ce-section-title ce-paragraph'>Financial Summary</div>
                        {getSummaryTable(props.calcs)}
                    </div>
                    <div className='ce-section-graph-left' style={{ 'height': '280px' }}>
                        <div>
                            <div className='highchart-left'><HighchartsReact highcharts={Highcharts} containerProps={{ style: { width: '356px', maxHeight: '210px', backgroundColor:'#f0f0f0' } }} options={premiumChart(props.calcs, years, abbreviation)} /></div>
                            <div>
                                <div className='ce-section-title'>Premium</div>
                                <p className='ce-paragraph'>
                                    The accompanying graph demonstrates the company’s growth in recent years.<span className='sentence-end'></span>Premium written, net premium and premium earned {comparePremium} by {premiumWritten}, {netPremiumWritten}, and {premiumEarned}, respectively, in the past <span className='no-break-span'>five years.</span><span className='sentence-end'></span>Over the past five years, increases in reinsurance costs combined with growth in the unearned premium reserve have limited the company’s growth in both net written premium and net earned premium.<span className='sentence-end'></span>While gross premium levels have increased, a greater portion of premium has been ceded to reinsurers and a larger balance has remained unearned at year-end, which has tempered the overall growth reflected in net premium metrics.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                {props.letterHead
                    ? (<div className='ce-letterhead-intro-bottom'>
                            <div className='ce-letterhead-bottom-slogan'>
                                <div className='ce-slogan'>
                                    BEYOND THE NUMBERS
                                </div>
                            </div>
                            <div className='ce-contact-container'>
                                <div className='ce-contact-info-container'>
                                    <img className='ce-leaf-icon' src={celeaf} alt="CE Leaf icon" /> 
                                    <div className='ce-contact-info'>
                                        <div style={{ 'marginBottom': '1px' }}>1008 Third Ave, PO Box 449, Sheldon, IA 51201</div>
                                        <div>712.324.4614</div>
                                    </div>
                                </div>
                                <div className='ce-contact-info-container'>
                                    <img className='ce-leaf-icon' src={celeaf} alt="CE Leaf icon" /> 
                                    <div className='ce-contact-info'>
                                        <div style={{ 'marginBottom': '1px' }}>5130 E 57th Street, Sioux Falls, SD 57108</div>
                                        <div>605.610.4611</div>
                                    </div>
                                </div>
                            </div>
                        </div>)
                    : <div className='ce-letterhead-bottom-empty' />}
            </div>
            <div className='ce-portrait-view-w-letterhead'>
                {props.letterHead
                ? <div className='ce-letterhead-top-container'>
                    <img className='ce-logo-circle-img' src={CELogoCircle} alt="CE Logo" />
                    <div className='ce-top-line'></div>
                </div>
                : <div className='ce-letterhead-top-container' />
                }
                <div className='ce-page-content'>
                    <div className='ce-section-graph-left'>
                        <div>
                            <div className='highchart-left'><HighchartsReact highcharts={Highcharts} containerProps={{ style: { width: '336px', maxHeight: '210px', backgroundColor:'#f0f0f0' } }} options={netPremiumWrittenToSurplus(props.calcs, years, abbreviation)} /></div>
                            <div>
                                <div className='ce-section-title'>Capacity</div>
                                <p className='ce-paragraph'>
                                A common ratio that is used in the industry
                                as a benchmark for capacity is the <span style={{'fontStyle': 'italic'}}>net premium-to-surplus ratio.</span> It is calculated
                                by comparing annual net premium written
                                to the amount of surplus at year end.<span className='sentence-end'></span>A
                                lower percentage represents a greater
                                ability to support premium growth.<span className='sentence-end'></span>The net
                                written premium-to-surplus ratio for {abbreviation} at December 31, {fye}, is {net_premium_to_surplus_ratio}.<span className='sentence-end'></span>The
                                average ratio for similar Iowa farm mutual
                                companies is {peers_net_premium_to_surplus_ratio}, ranging from a low of {min_peers_net_premium_to_surplus_ratio} to a high of {max_peers_net_premium_to_surplus_ratio}.<span className='sentence-end'></span>As the
                                accompanying graph demonstrates, {abbreviation} has a {compare_net_premium_to_surplus_ratio} net written premium-to-surplus than its
                                peers.<span className='sentence-end'></span>This would generally be interpreted to mean that {abbreviation} has {compare_capacity} capacity for business
                                growth than does the average company in the peer group.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className='ce-section-title'>Liquidity</div>
                        <p className='ce-paragraph'>
                            <span style={{'fontStyle': 'italic'}}>Liquidity</span> is a measure of management’s ability to generate sufficient cash flows to meet the short
                            and long term cash requirements for business operations.<span className='sentence-end'></span>After satisfying cash requirements,
                            excess cash flows are used to build the investment portfolio and thereby increase future
                            investment income.
                        </p>
                    </div>
                    <div className="ce-section-graph-right" style={{'minHeight': '200px'}}>
                        <div>
                            <div
                                className='highchart-right'
                                style={{
                                    width: '336px',
                                    height: '210px',
                                }}
                            >
                            <HighchartsReact
                                highcharts={Highcharts}
                                containerProps={{ style: {
                                    width: '336px',
                                    height: '210px',
                                } }}
                                options={liquidityRatio(props.calcs, years, abbreviation, false)}
                            />
                            </div>
                            <p className='ce-paragraph'>
                                The <span style={{'fontStyle': 'italic'}}>liquidity ratio</span> is calculated by dividing total admitted assets by total
                                liabilities.<span className='sentence-end'></span>A ratio of less than 100% indicates an undesirable situation.<span className='sentence-end'></span>Ratio values greater than 100% indicate that the insurer could cover the balance sheet values of all its liabilities by
                                converting assets to cash.<span className='sentence-end'></span>It is worth noting that the liabilities of an insurance company can change quickly and significantly with the next catastrophic event.<span className='sentence-end'></span>The liquidity ratio for {abbreviation} at
                                December 31, {fye}, was {liquidity_ratio}.<span className='sentence-end'></span>A higher
                                percentage represents a stronger liquidity
                                position.<span className='sentence-end'></span>For comparison purposes, the
                                average ratio for similar Iowa farm
                                mutual companies is {peers_liquidity_ratio}, ranging from
                                a low of {min_peers_liquidity_ratio} to a high {max_peers_liquidity_ratio}.
                            </p>
                        </div>
                    </div>
                </div>
                {props.letterHead
                    ? (<div className='ce-letterhead-intro-bottom'>
                            <div className='ce-letterhead-bottom-slogan'>
                                <div className='ce-slogan'>
                                    BEYOND THE NUMBERS
                                </div>
                            </div>
                            <div className='ce-page-footer'>2</div>
                        </div>)
                    : (<div className='ce-letterhead-bottom-pagenum-only'>
                            <div className='ce-page-footer'>2</div>
                        </div>)
                }
            </div>
            <div className='ce-portrait-view-w-letterhead'>
                {props.letterHead
                ? <div className='ce-letterhead-top-container'>
                    <img className='ce-logo-circle-img' src={CELogoCircle} alt="CE Logo" />
                    <div className='ce-top-line'></div>
                </div>
                : <div className='ce-letterhead-top-container' />
                }
                <div className='ce-page-content'>
                    <div className='ce-section-graph-right' style={{'minHeight': '200px'}}>
                        <div>
                            <div className='ce-section-title'>Profitability</div>
                            <div>
                                <div className='highchart-right'><HighchartsReact highcharts={Highcharts} containerProps={{ style: { width: '335px', minHeight: '223px', maxHeight: '223px', backgroundColor:'#f0f0f0' } }} options={combinedRatio(props.calcs, years, abbreviation, 'combined_ratio_no_five_year_avg', 'Combined Ratio - 5-Yr Avg', 223)} /></div>
                                <p className='ce-paragraph'>
                                    The Company’s underwriting results for {fye} reflects a {compareUnderwritingGainLoss} of {underwriting_gain_loss}.<span className='sentence-end'></span>Losses
                                    incurred and operating expenses {compareNetLossAndOpex} from the previous year by {net_losses_incurredYOY} and {operating_expensesYOY},
                                    respectively.
                                </p>
                                <p className='ce-paragraph'>
                                    The combined loss and expense ratio,
                                    expressed as a percentage, is the key
                                    measure of underwriting profitability.
                                    When the <span style={{ 'fontStyle': 'italic' }}>combined ratio</span> is under 100%,
                                    underwriting results are profitable; when
                                    the combined ratio exceeds 100%, underwriting results are unprofitable.<span className='sentence-end'></span>The combined ratio for {abbreviation} for {fye} was {combined_ratio_no_one_year}, compared to the peer average of {peers_combined_ratio_no_one_year} for the year.<span className='sentence-end'></span>The company’s
                                    average combined ratio for the last five years is {combined_ratio_no_five_year_avg}.<span className='sentence-end'></span>The five-year average ratio for similar
                                    Iowa farm mutual insurance companies is {peers_combined_ratio_no_five_year_avg}.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className='ce-section-graph-right' style={{'minHeight': '200px'}}>
                        <div>
                            <div className='ce-section-title'>Operating Efficiency</div>
                            <div>
                                <div className='highchart-right'><HighchartsReact highcharts={Highcharts} containerProps={{ style: { width: '335px', minHeight: '223px', maxHeight: '223px', backgroundColor:'#f0f0f0' } }} options={opexRatio(props.calcs, years, abbreviation, 'Operating Expense Ratio', 223)} /></div>
                                <p className='ce-paragraph'>
                                    There are two key ratios we recommend
                                    tracking to measure management’s ability
                                    to gain operating efficiency.
                                </p>
                                <p className='ce-paragraph'>
                                    The first is the  <span style={{ 'fontStyle': 'italic' }}>operating expense ratio</span>.<span className='sentence-end'></span>It
                                    is calculated by comparing annual
                                    operating expense to premium income.
                                    Either premium written or premium earned
                                    can be used as the denominator in the
                                    calculation.<span className='sentence-end'></span>We prefer to use premium
                                    written because we think it enhances the ability to perform peer comparisons.<span className='sentence-end'></span>The expense ratio
                                    for {abbreviation} for {fye} was {operating_expense_ratio}.<span className='sentence-end'></span>The average ratio for similar Iowa farm mutual companies with
                                    whom we work is {peers_operating_expense_ratio}, ranging from a low of {min_peers_operating_expense_ratio} to a high of {max_peers_operating_expense_ratio}.<span className='sentence-end'></span>A lower expense ratio
                                    allows the company to absorb a higher loss ratio and still have the opportunity to experience
                                    favorable underwriting results.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                {props.letterHead
                    ? (<div className='ce-letterhead-intro-bottom'>
                            <div className='ce-letterhead-bottom-slogan'>
                                <div className='ce-slogan'>
                                    BEYOND THE NUMBERS
                                </div>
                            </div>
                            <div className='ce-page-footer'>3</div>
                        </div>)
                    : (<div className='ce-letterhead-bottom-pagenum-only'>
                            <div className='ce-page-footer'>3</div>
                        </div>)
                }
            </div>
            <div className='ce-portrait-view-w-letterhead'>
                {props.letterHead
                ? <div className='ce-letterhead-top-container'>
                    <img className='ce-logo-circle-img' src={CELogoCircle} alt="CE Logo" />
                    <div className='ce-top-line'></div>
                </div>
                : <div className='ce-letterhead-top-container' />
                }
                <div className='ce-page-content'>
                    <div className='ce-section-graph-left'>
                        <div>
                            <div className='highchart-left'><HighchartsReact highcharts={Highcharts} containerProps={{ style: { width: '336px', maxHeight: '221px', backgroundColor:'#f0f0f0' } }} options={breakEvenRatio(props.calcs, years, abbreviation, 'break_even_ratio_no', 'Break-Even Analysis', false, 221)} /></div>
                            <div>
                                <p className='ce-paragraph'>
                                    The second is the <span style={{ 'fontStyle': 'italic' }}>break-even ratio</span>.<span className='sentence-end'></span>It is calculated using the following formula:
                                </p>
                                <div style={{ 'display': 'flex', 'flexDirection': 'column', 'alignItems': 'center', 'marginBottom': '16px' }}>
                                    <span>Combined ratio minus</span>
                                    <span>(operating expenses ÷ premiums earned) </span>
                                </div>
                                <p className='ce-paragraph'>
                                    The ratio represents the point at which any increase in the loss ratio will produce an
                                    underwriting loss.<span className='sentence-end'></span>The higher the break-even loss ratio, the more losses the company can absorb before underwriting results become
                                    unprofitable.<span className='sentence-end'></span>{abbreviation} had a break-even ratio of {break_even_ratio} for {fye}.<span className='sentence-end'></span>The average break-even ratio for similar Iowa
                                    farm mutual companies with whom we work is also {peers_break_even_ratio}, ranging from a low of {min_peers_break_even_ratio} to a high of {max_peers_break_even_ratio}.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className='ce-section-graph-right' style={{'minHeight': '226px'}}>
                        <div className='highchart-right'><HighchartsReact highcharts={Highcharts} containerProps={{ style: { width: '336px', maxHeight: '204px', backgroundColor:'#f0f0f0' } }} options={reinsuranceToGPW(props.calcs, years, abbreviation, 204)} /></div>
                        <div>
                            <div className='ce-section-title'>Reinsurance</div>
                            <p className='ce-paragraph' style={{'lineHeight': '1.3'}}>
                                The pace of reinsurance rate increases has moderated compared to peak hard-<span className='no-break-span'>market conditions</span>  in prior years.<span className='sentence-end'></span>The
                                accompanying graph illustrates the trend in reinsurance cost for {abbreviation}.<span className='sentence-end'></span>In {fye}, the cost
                                of reinsurance for {abbreviation} was {reinsurance_to_gpw_ratio} of premium written.<span className='sentence-end'></span>The same ratio for the peer group
                                was {peers_reinsurance_to_gpw_ratio}, ranging from a low of {min_peers_reinsurance_to_gpw_ratio} to a high of {max_peers_reinsurance_to_gpw_ratio}.
                            </p>
                        </div>
                    </div>
                    <div className='ce-section-graph-right'>
                        <div className='highchart-right'><HighchartsReact highcharts={Highcharts} containerProps={{ style: { width: '336px', maxHeight: '204px', backgroundColor:'#f0f0f0' } }} options={surplusToGRIF000s(props.calcs, years, abbreviation, 204)} /></div>
                        <div>
                            <div className='ce-section-title'>Financial Resources</div>
                            <p className='ce-paragraph' style={{'lineHeight': '1.3'}}>
                                <span style={{ 'fontStyle': 'italic' }}>Financial resources</span> provide protection for
                                policyholders and the financial strength to
                                support continued business growth.<span className='sentence-end'></span>At
                                December 31, {fye}, {abbreviation} had total surplus of {surplus}.<span className='sentence-end'></span>Surplus {compare_surplus} by {finalDifSurplus} or {surplusYOY} during {fye}.<span className='sentence-end'></span>The accompanying graph
                                demonstrates how surplus has grown in relation to the growth in gross property risk in force.
                            </p>
                        </div>
                    </div>
                </div>
                {props.letterHead
                    ? (<div className='ce-letterhead-intro-bottom'>
                            <div className='ce-letterhead-bottom-slogan'>
                                <div className='ce-slogan'>
                                    BEYOND THE NUMBERS
                                </div>
                            </div>
                            <div className='ce-page-footer'>4</div>
                        </div>)
                    : (<div className='ce-letterhead-bottom-pagenum-only'>
                            <div className='ce-page-footer'>4</div>
                        </div>)
                }
            </div>
            <div className='ce-portrait-view-w-letterhead'>
                {props.letterHead
                ? <div className='ce-letterhead-top-container'>
                    <img className='ce-logo-circle-img' src={CELogoCircle} alt="CE Logo" />
                    <div className='ce-top-line'></div>
                </div>
                : <div className='ce-letterhead-top-container' />
                }
                <div className='ce-page-content'>
                    <div className="ce-section">
                        <div className='ce-section-title'>Investments and Statutory Compliance</div>
                        <p className='ce-paragraph'>
                            For financial statment purposes and in accordance with statutory requirements, fixed income
                            securities are presented at the lower of amortized cost or fair value and equity securities at fair
                            value.<span className='sentence-end'></span>Investments, at statutory values, totaled {investments} at December 31, {fye}, and {compare_investments} by {investmentsYOY} from the previous year.
                        </p>
                        <p className='ce-paragraph'>
                            Based on December 31, {fye}, the following limitations apply to your Company’s
                            invested assets for {nextYear}:
                        </p>
                        <ul className='ce-section-list'>
                            <li>
                                The aggregate amount invested in stocks and stock equivalents cannot exceed {surplus50}.<span className='sentence-end'></span><span className='no-break-span'>(50% of Surplus)</span>
                            </li>
                            <li>
                                Amounts invested in the stock or stock equivalents of any one corporation cannot exceed {surplus10}.<span className='sentence-end'></span><span className='no-break-span'>(10% of Surplus)</span>
                            </li>
                            <li>
                                The aggregate amount invested in non-dividend paying stocks or stock equivalents cannot
                                exceed {surplus5}.<span className='sentence-end'></span><span className='no-break-span'>(5% of Surplus)</span>
                            </li>
                            <li>
                                Amounts invested in the debt obligations of any one corporation or business trust cannot
                                exceed {admitted_assets5}.<span className='sentence-end'></span><span className='no-break-span'>(5% of Admitted Assets)</span>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <p className='ce-paragraph'>
                            If you have any questions or need clarification on any of the information in this letter, please do
                            not hesitate to contact us.<span className='sentence-end'></span>Thank you for giving us the opportunity to serve you.<span className='sentence-end'></span>We are honored
                            to be your accountants and tax advisors.
                        </p>
                        <div className='ce-signature-container'>
                            <div className='ce-sign-margin'>
                                <img className='ce-logo-jpg' src={CEsignature} alt="CE signature" />
                                <div>Cain Ellsworth & Co., LLP</div>
                                <div>Certified Public Accountants</div>
                            </div>
                        </div>
                        <div>
                            <div>Sheldon, Iowa</div>
                            <div>{formattedDate}</div>
                        </div>
                    </div>
                </div>
                {props.letterHead
                    ? (<div className='ce-letterhead-intro-bottom'>
                            <div className='ce-letterhead-bottom-slogan'>
                                <div className='ce-slogan'>
                                    BEYOND THE NUMBERS
                                </div>
                            </div>
                            <div className='ce-page-footer'>5</div>
                        </div>)
                    : (<div className='ce-letterhead-bottom-pagenum-only'>
                            <div className='ce-page-footer'>5</div>
                        </div>)
                }
            </div>
        </div>
    )
}

export default IowaReport;